import { render, staticRenderFns } from "./icon-mp4.vue?vue&type=template&id=1834b5b3&"
import script from "./icon-mp4.vue?vue&type=script&lang=js&"
export * from "./icon-mp4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports